import { BaseService } from '@/modules/Core/services/BaseService'
import type { IMediTransacciones } from '@/modules/Farmacia/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces'
import type { IDeleteWithReason, IMediTransaccionDetail } from '../interfaces/tablas/IMediTransacciones'
import type { ITiposGeneralTransaccion } from '../interfaces/ITransaccion'
export class TransaccionesService extends BaseService<IMediTransacciones> {
  constructor() {
    super({
      baseUrl: 'medicines/medicines/transaction/'
    })
  }
  async getTransacciones(
    id: string | string[],
    tipo: number
  ): Promise<AxiosResponse<IResponseApi<IMediTransacciones[]>>> {
    return this.http.get<IResponseApi<IMediTransacciones[]>>(
      `search?mediId=${id}&metrTipo=${tipo}`
    )
  }
  async searchByName(
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IMediTransacciones[]>>> {
    return this.http.get<IResponseApi<IMediTransacciones[]>>(`search-by-name`, {
      params
    })
  }
  async searchLotesByMedicine(
    medicineId: number
  ): Promise<AxiosResponse<IResponseApi<IMediTransacciones[]>>> {
    return this.http
      .get<
        IResponseApi<IMediTransacciones[]>
      >(`/search-lotes-by-medicine/${medicineId}`)
      .catch(this.errorHandle)
  }
  async facturarExterna(
    payload: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http
      .post<IResponseApi<string>>(`/facturar-externa`, payload)
      .catch(this.errorHandle)
  }
  async getTiposGenerales(): Promise<
    AxiosResponse<IResponseApi<ITiposGeneralTransaccion>>
  > {
    return this.http.get<IResponseApi<ITiposGeneralTransaccion>>(`/general`)
  }
  async deleteWithReason(
    body: IDeleteWithReason
  ): Promise<AxiosResponse<IResponseApi<IMediTransacciones>>> {
    return this.http
      .post<IResponseApi<IMediTransacciones[]>>(`/deleteWithReason`, body)
      .catch(this.errorHandle)
  }
  async createSalida(
    body: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http
      .post<IResponseApi<string>>(`/createSalida`, body)
      .catch(this.errorHandle)
  }
  async getDetailOne(
    metrId: number
  ): Promise<AxiosResponse<IResponseApi<IMediTransaccionDetail>>> {
    return this.http
      .get<
        IResponseApi<IMediTransaccionDetail>
      >(`/getDetailOne/${metrId}`)
      .catch(this.errorHandle)
  }
}





